(function () {
  function getCachedProduct(el) {
    const cache = window.Shir7ReviewsCache;
    if (!cache) return null;

    const id = (el.getAttribute('data-product-id') || '').trim();
    const handle = (el.getAttribute('data-product-handle') || '').trim();
    const cachedId = id || cache.handles?.[handle];

    return (cachedId && cache.products?.[cachedId]) || (handle && cache.products?.[cache.handles?.[handle]]) || null;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function stars(rating) {
    const safeRating = Math.max(0, Math.min(5, Number(rating) || 0));
    const filled = Math.max(0, Math.min(5, Math.round(safeRating)));
    let icons = '';
    for (let i = 1; i <= 5; i++) {
      icons +=
        '<span class="shir7-star' +
        (i <= filled ? ' shir7-star--on' : '') +
        '" aria-hidden="true">★</span>';
    }
    return (
      '<span class="shir7-stars" role="img" aria-label="' +
      safeRating.toFixed(1) +
      ' de 5">' +
      icons +
      '</span>'
    );
  }

  function getAssetBase() {
    const configuredBase = window.Shir7BkRatings?.assetBase;
    if (configuredBase) {
      return configuredBase.split('?')[0];
    }

    const cacheScript = document.querySelector('script[src*="shir7-reviews-cache.js"]');
    if (!cacheScript) return '';

    try {
      const url = new URL(cacheScript.getAttribute('src'), window.location.href);
      url.pathname = url.pathname.replace(/shir7-reviews-cache\.js$/, '');
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (e) {
      return '';
    }
  }

  function getImageSources(review) {
    const assetBase = getAssetBase();
    const assetImages = (review.assetImages || []).map((name) => {
      const file = String(name).replace(/\.(png|jpe?g)$/i, '.webp');
      return assetBase + encodeURIComponent(file);
    });
    return assetImages.length ? assetImages : review.images || [];
  }

  function reviewImages(review) {
    const images = getImageSources(review).slice(0, 4);
    if (!images.length) return '';

    return (
      '<div class="shir7-review-card__images">' +
      images
        .map(
          (src) =>
            '<button type="button" class="shir7-review-image-button" data-shir7-review-image="' +
            escapeHtml(src) +
            '"><img loading="lazy" width="120" height="120" src="' +
            escapeHtml(src) +
            '" alt="Foto enviada por cliente"></button>'
        )
        .join('') +
      '</div>'
    );
  }

  function reviewCardHtml(review) {
    return (
      '<article class="shir7-review-card">' +
      '<div class="shir7-review-card__top"><strong>' +
      escapeHtml(review.author || 'Cliente') +
      '</strong>' +
      stars(review.rating || 5) +
      '</div>' +
      (review.comment ? '<p>' + escapeHtml(review.comment) + '</p>' : '') +
      reviewImages(review) +
      '</article>'
    );
  }

  function bindReviewsCarousel(root) {
    const track = root.querySelector('[data-shir7-reviews-track]');
    const prev = root.querySelector('[data-shir7-reviews-prev]');
    const next = root.querySelector('[data-shir7-reviews-next]');
    const dots = root.querySelectorAll('[data-shir7-reviews-dot]');
    if (!track) return;

    const cards = Array.from(track.querySelectorAll('.shir7-review-card'));
    if (!cards.length) return;

    function currentIndex() {
      const left = track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, index) => {
        const dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    }

    function goTo(index) {
      const safe = Math.max(0, Math.min(cards.length - 1, index));
      const card = cards[safe];
      track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === safe);
      });
    }

    if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.getAttribute('data-shir7-reviews-dot')) || 0));
    });

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const index = currentIndex();
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function renderSummaries() {
    document.querySelectorAll('.shir7-product-rating-summary--pending').forEach((el) => {
      const product = getCachedProduct(el);
      if (!product) {
        el.remove();
        return;
      }

      el.classList.remove('shir7-product-rating-summary--pending');
      el.innerHTML =
        stars(product.averageRating) +
        '<a href="#shir7-product-reviews" class="shir7-product-rating-summary__count">(' +
        product.reviewAmount +
        ' avaliações)</a>';
    });
  }

  function renderProductReviews() {
    document.querySelectorAll('.shir7-product-reviews-static--pending').forEach((el) => {
      const product = getCachedProduct(el);
      if (!product || !product.reviewAmount) {
        el.remove();
        return;
      }

      const reviewsDesktop = (product.reviews || []).slice(0, 9);
      const reviewsMobile = (product.reviews || []).slice(0, 5);
      const photoUrls = reviewsDesktop.flatMap((review) => getImageSources(review)).slice(0, 8);

      el.id = 'shir7-product-reviews';
      el.classList.remove('shir7-product-reviews-static--pending');
      el.innerHTML =
        '<div class="shir7-product-reviews__header">' +
        '<h2>Avaliações de clientes</h2>' +
        '<div class="shir7-product-reviews__summary">' +
        stars(product.averageRating) +
        '<strong>' +
        Number(product.averageRating || 0).toFixed(1) +
        '</strong><span>(' +
        product.reviewAmount +
        ' avaliações)</span></div></div>' +
        (photoUrls.length
          ? '<div class="shir7-product-reviews__photos">' +
            photoUrls
              .map(
                (src) =>
                  '<button type="button" class="shir7-review-image-button" data-shir7-review-image="' +
                  escapeHtml(src) +
                  '"><img loading="lazy" src="' +
                  escapeHtml(src) +
                  '" alt="Foto de avaliação de cliente"></button>'
              )
              .join('') +
            '</div>'
          : '') +
        '<div class="shir7-product-reviews__grid small-hide">' +
        reviewsDesktop.map(reviewCardHtml).join('') +
        '</div>' +
        '<div class="shir7-product-reviews__carousel medium-hide large-up-hide" data-shir7-reviews-carousel>' +
        '<div class="shir7-product-reviews__track" data-shir7-reviews-track>' +
        reviewsMobile.map(reviewCardHtml).join('') +
        '</div>' +
        (reviewsMobile.length > 1
          ? '<div class="shir7-product-reviews__controls">' +
            '<button type="button" class="shir7-product-reviews__arrow" data-shir7-reviews-prev aria-label="Avaliação anterior">‹</button>' +
            '<div class="shir7-product-reviews__dots">' +
            reviewsMobile
              .map(
                (_, index) =>
                  '<button type="button" class="shir7-product-reviews__dot' +
                  (index === 0 ? ' is-active' : '') +
                  '" data-shir7-reviews-dot="' +
                  index +
                  '" aria-label="Ir para avaliação ' +
                  (index + 1) +
                  '"></button>'
              )
              .join('') +
            '</div>' +
            '<button type="button" class="shir7-product-reviews__arrow" data-shir7-reviews-next aria-label="Próxima avaliação">›</button>' +
            '</div>'
          : '') +
        '</div>';

      bindReviewsCarousel(el);
    });
  }

  function hideBkProductWidgets() {
    document.querySelectorAll('.bk-reviews:not(.shir7-card-rating)').forEach((el) => {
      if (!el.closest('.product-card-wrapper')) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function openImageModal(src) {
    let modal = document.querySelector('.shir7-review-image-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'shir7-review-image-modal';
      modal.innerHTML =
        '<div class="shir7-review-image-modal__backdrop" data-shir7-close-modal></div>' +
        '<div class="shir7-review-image-modal__dialog" role="dialog" aria-modal="true" aria-label="Foto da avaliação">' +
        '<button type="button" class="shir7-review-image-modal__close" data-shir7-close-modal aria-label="Fechar">×</button>' +
        '<img alt="Foto da avaliação ampliada">' +
        '</div>';
      document.body.appendChild(modal);
    }

    modal.querySelector('img').src = src;
    modal.classList.add('is-open');
    document.documentElement.classList.add('shir7-review-modal-open');
  }

  function closeImageModal() {
    const modal = document.querySelector('.shir7-review-image-modal');
    if (!modal) return;

    modal.classList.remove('is-open');
    document.documentElement.classList.remove('shir7-review-modal-open');
  }

  function run() {
    let tries = 0;
    function attempt() {
      if (window.Shir7ReviewsCache || tries > 40) {
        renderSummaries();
        renderProductReviews();
        hideBkProductWidgets();
        return;
      }
      tries += 1;
      setTimeout(attempt, 50);
    }
    attempt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(run, 800);
  setTimeout(hideBkProductWidgets, 2500);

  document.addEventListener('click', (event) => {
    const imageButton = event.target.closest('[data-shir7-review-image]');
    if (imageButton) {
      openImageModal(imageButton.getAttribute('data-shir7-review-image'));
      return;
    }

    if (event.target.closest('[data-shir7-close-modal]')) {
      closeImageModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeImageModal();
  });
})();
